{
  "version": 1,
  "asset_id": "9dfbf229-4dc8-4b33-a9b5-88427857ea5b",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/9dfbf229-4dc8-4b33-a9b5-88427857ea5b/skrill.svg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/9dfbf229-4dc8-4b33-a9b5-88427857ea5b/skrill.svg",
  "original_filename": "skrill.svg",
  "size": 1280,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-30T15:11:43Z"
}
